import React from 'react';
import { Check } from 'lucide-react';
import { detoxFoodOverview } from '../data/detoxFoods';

export const FoodsOverviewChart = ({
  title = 'Foods that Nourish for our 7 Day Journey — An Overview',
  subtitle = 'Your at-a-glance guide to what nourishes — and what to set aside — for these 7 days.',
  foods = detoxFoodOverview,
  footnote = 'A flexible framework, not a rulebook — adapt it to your body, your needs, and any restrictions. When in doubt, choose whole and colorful.',
}) => (
  <div>
    <div className="rounded-2xl overflow-hidden border border-stone-200 shadow-sm" data-testid="foods-overview-chart">
      <div className="bg-gradient-to-r from-emerald-100 via-amber-50 to-rose-100 px-6 py-5 text-center border-b border-stone-200">
        <h3 className="font-heading text-2xl text-forest">{title}</h3>
        <p className="text-sm font-body text-stone-600 mt-1">{subtitle}</p>
      </div>

      {/* Header row (desktop) */}
      <div className="hidden md:grid grid-cols-[200px_1fr_1fr] bg-stone-50 border-b border-stone-200">
        <div className="px-5 py-3 font-heading text-forest text-sm uppercase tracking-wide">Foods</div>
        <div className="px-5 py-3 font-heading text-emerald-800 text-sm uppercase tracking-wide flex items-center gap-2">
          <Check size={14} className="text-emerald-600" /> Yes to these
        </div>
        <div className="px-5 py-3 font-heading text-rose-800 text-sm uppercase tracking-wide">No to these</div>
      </div>

      {foods.map((row, i) => (
        <div
          key={row.food}
          className={`md:grid md:grid-cols-[200px_1fr_1fr] border-b border-stone-100 last:border-b-0 ${i % 2 === 0 ? 'bg-white' : 'bg-stone-50/50'}`}
        >
          <div className="px-5 py-3 font-body font-medium text-forest md:border-r md:border-stone-100">{row.food}</div>
          <div className="px-5 py-3 font-body text-sm text-stone-700 bg-emerald-50/50 md:border-r md:border-stone-100">
            <span className="md:hidden text-xs uppercase tracking-wide text-emerald-700 font-medium block mb-1">Yes to these</span>
            {row.yes}
          </div>
          <div className="px-5 py-3 font-body text-sm text-stone-700 bg-rose-50/40">
            <span className="md:hidden text-xs uppercase tracking-wide text-rose-700 font-medium block mb-1">No to these</span>
            {row.no}
          </div>
        </div>
      ))}
    </div>
    {footnote && <p className="text-xs font-body text-stone-400 italic mt-3">{footnote}</p>}
  </div>
);

export default FoodsOverviewChart;
